module.exports = __webpack_public_path__ + "static/media/youtube.e230c66d.svg";